import React from 'react';
import { X } from 'lucide-react';

interface TutorialOverlayProps {
  onClose: () => void;
}

/**
 * Tutorial Overlay Component
 * Shows helpful tips for first-time users
 */
const TutorialOverlay: React.FC<TutorialOverlayProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 animate-fade-in">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl mx-4 p-8 animate-bounce-in">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X size={24} />
        </button>

        {/* Content */}
        <div className="text-center mb-6">
          <div className="text-6xl mb-4">🎉</div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            Welcome to Funnel Builder!
          </h2>
          <p className="text-gray-600">
            You just added your first element. Here's how to use it:
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-4 mb-8">
          <div className="flex items-start gap-4 p-4 bg-primary-50 rounded-lg border-2 border-primary-200">
            <div className="flex-shrink-0 w-8 h-8 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold">
              1
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Click to Select</h3>
              <p className="text-sm text-gray-600">
                Click on any element on the canvas to select it
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-4 bg-primary-50 rounded-lg border-2 border-primary-200">
            <div className="flex-shrink-0 w-8 h-8 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold">
              2
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Edit Properties</h3>
              <p className="text-sm text-gray-600">
                The right panel will show editing options. Changes apply instantly!
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-4 bg-primary-50 rounded-lg border-2 border-primary-200">
            <div className="flex-shrink-0 w-8 h-8 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold">
              3
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Style & Customize</h3>
              <p className="text-sm text-gray-600">
                Use the Style, Layout, and Responsive tabs to customize appearance
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={onClose}
            className="px-8 py-3 bg-gradient-to-r from-primary-600 to-primary-700 text-white font-semibold rounded-lg hover:from-primary-700 hover:to-primary-800 transform hover:scale-105 transition-all shadow-lg"
          >
            Got it! Let's build 🚀
          </button>
        </div>
      </div>
    </div>
  );
};

export default TutorialOverlay;

